
// * ========================================================================
// * ages chart and table
// * ========================================================================

import Tablesorter from './../table-sorter';
import CovidChart from './covid-chart.js';
import moment from 'moment';
import storage from './../storage';

const ages = (function(){
    let thisChart = null;
    let dataType = null;
    let typeSelectors = null;
    const typeSelectorClass = 'input[name=ages-total-chart-data]';
    let chartData = null;
    let chartFirstDate = null;

    /**
     *
     * Show new cases per day table
     *
     * @param {Array} data - covid data
     */
    function showTable(data) {
        const nameValues = {
            'alle 10 v': 9,
            'yli 80 v': 81
        };

        const firstDate = chartFirstDate.format('D.M') + '. jälkeen';
        let headings = '<th data-sort="number" data-default-sort-dir="up">Ikäryhmä</th>';
        headings += '<th data-sort="number" class="align-right">Yhteensä</th>';
        headings += '<th data-sort="number" class="align-right">'+firstDate+'</th>';
        headings += '<th data-sort="number" class="align-right sorting">Uusia</th>';

        const markup = ['<tr>'+headings+'</tr>'];
        for (let age of data.ages) {
            const count = age.count === 0 ? 0 : age.count;
            const countStr = age.count === 0 ? '0 - 4' : count;

            const change = age.count === 0 ? 0 : age.change;
            const changeStr = age.count === 0 ? '' : change ? change > 0 ? '<span class="color-red">+'+age.change+'</span>' : age.change : 0;

            const newCount = count - age.firstDayValue;
            const nameValue = typeof nameValues[age.name] !== 'undefined' ? nameValues[age.name] : parseInt(age.name);

            let content = '<td data-dataset-id="'+ age.slug +'" data-value="'+nameValue+'">'+age.name+'</td>';
            content += '<td data-value="'+count+'" class="align-right">'+countStr+'</td>';
            content += '<td data-value="'+newCount+'" class="align-right">'+newCount+'</td>';
            content += '<td data-value="'+change+'" class="align-right">'+changeStr+'</td>';

            markup.push('<tr>'+content+'</tr>');
        }

        const tableContainer = document.querySelector('#ages-total-table');
        tableContainer.innerHTML = '<table class="table">'+markup.join('')+'</table>';
        const table = tableContainer.querySelector('table');

        const tablesorter = new Tablesorter(table);

        // Set new order
        const sorter = table.querySelector('th.sorting');
        tablesorter.sortBy(sorter);
    }

    function createChartData(data, options, selected) {
        const datasets = [];
        const dates = {};

        let idx = 0;
        for (const age of data.ages) {
            datasets.push({
                label: age.name,
                id: age.slug,
                borderColor: options.chartColors[idx],
                borderWidth: 3,
                count: age.count,
                fill: false,
                data: [],
                pointRadius: 0,
                type: 'LineWithLine',
                selected: selected && Array.isArray(selected) ? selected.indexOf(age.slug) !== -1 : true
            });

            // Per date
            for (const day of age.days) {
                if (typeof dates[day.date] === 'undefined') {
                    dates[day.date] = moment(day.date);
                    dates[day.date].set({
                        hour: 0,
                        minute: 0,
                        second: 0
                    });
                }

                const newDate = dates[day.date];
                if (newDate >= chartFirstDate) {
                    const count = dataType === 'date' ? day.count - age.firstDayValue : day.count;

                    datasets[idx].data.push({
                        x: newDate,
                        y: count
                    });
                }
            }

            idx++;
        }

        return datasets;
    }

    function getDataType() {
        dataType = document.querySelector(typeSelectorClass+':checked').value;
        return dataType;
    }

    /**
     * Initialize
     *
     * @param {Object} data - covid data
     */
    function init(data) {
        chartData = data;
        chartFirstDate = window.config.firstDayValues['ages'];

        typeSelectors = document.querySelectorAll(typeSelectorClass);
        getDataType();

        showTable(chartData);

        // Initially selected
        let selectedAges = storage.getData('ages-total-chart_multiselect');
        if (!selectedAges || !Array.isArray(selectedAges)) {
            selectedAges = null;
        }

        const datasets = createChartData(chartData, window.config, selectedAges);

        thisChart = new CovidChart('ages-total-chart', {
            datasets,
            chartOptions: {
                options: {
                    plugins: {
                        tooltip: {
                            enabled: false,
                            mode: 'index',
                            intersect: false,
                            position: 'nearest',
                            bodySpacing: 5,
                            itemSort: function(a, b, data) {
                                return b.yLabel > a.yLabel ? 1 : -1;
                            }
                        },
                    },
                    scales: {
                        x: {
                            type: 'time',
                            time: {
                                unit: 'day',
                                displayFormats: {
                                    day: 'D.M',
                                }
                            },
                            title: {
                                display: false,
                                text: 'Päivämäärä'
                            },
                            ticks: {
                                major: {
                                    fontStyle: 'bold',
                                    fontColor: '#FF0000'
                                }
                            }
                        },
                        y: {
                            title: {
                                display: false,
                                text: 'Tartuntojen määrä'
                            },
                            ticks: {
                                precision: 0
                            }
                        }
                    }
                }
            },
            config: window.config,
            tooltips: {
                elementId: 'ages-total-chart-tooltip'
            },
            multiselect: {
                requireCount: false,
                valueType: 'string',
                idField: 'id',
                colorField: 'borderColor',
                inputName: 'ages-multiselect',
                selectElemId: 'ages-multiselect',
                colorElemId: 'ages-multiselect-colors',
                countElemId: 'ages-multiselect-count',
                selectAllElemId: 'ages-multiselect-select-all',
                clearAllElemId: 'ages-multiselect-clear-all'
            },
            responsive: ['aspectRatio']
        });

        // Create listener for type change
        typeSelectors.forEach((typeSelector) => {
            typeSelector.addEventListener('change', () => {
                let newType = document.querySelector(typeSelectorClass+':checked').value;
                if (dataType !== newType) {
                    reload(null, true);
                }
            });
        });
    }

    function reload(data = null, changeType = false) {
        if (data) {
            chartData = data;
        }

        // Get the data type we want to show
        getDataType();

        if (!changeType) {
            // New first date value
            chartFirstDate = window.config.firstDayValues['ages'];

            // Re render table
            showTable(chartData);
        }

        const datasets = createChartData(chartData, window.config);

        // Update datasets
        thisChart.updateDatasets(datasets, true);
    }

    return {
        init,
        reload
    }

})();

export default ages;
